import { useConfigContext } from "@/app";
import { Icon } from "@/components/Icon";
import { Level } from "@/components/Level";
import { PaymentIcons } from "@/components/PaymentIcons";
import { OrderType } from "@/constants";
import { cn } from "@/libs";
import { ComponentBase } from "@/types";
import { MarketPendingOrderList } from "@/types/Api/Market/PendingOrder/marketPendingOrderList";
import { amountFormat } from "@/utils/tool";
import { Avatar } from "antd-mobile";
import styles from "./Item.module.scss";
import { useUserInfoStore } from "@/stores/userInfo";
export interface ItemProps extends ComponentBase.BaseComponent {
  item: MarketPendingOrderList["response"]["list"][0];
}
export const Item = ({
  item,
  ...args
}: ItemProps) => {
  const {
    getSourcePath,
    config
  } = useConfigContext();
  const userInfo = useUserInfoStore()(state => state.userInfo);
  console.log('creditLevel==', userInfo.creditLevel, item.sellerCreditLevel);
  return <div className={styles.itemWrapper} {...args} data-sentry-component="Item" data-sentry-source-file="Item.tsx">
      <div className={styles.top}>
        {item.sellerAvatar ? <Avatar className={styles.avatar} src={getSourcePath(item.sellerAvatar)} /> : <div className={cn(styles.avatar, styles.defaultAvatar)}></div>}
        
        <div className={styles.info}>
          <div className={styles.infoTop}>
            <div className={styles.name}>{item.sellerNickname}</div>
            <div className={styles.payments}>
              <PaymentIcons payments={item.paymentType} data-sentry-element="PaymentIcons" data-sentry-source-file="Item.tsx" />
            </div>
          </div>
          {/* <div className={styles.levelWrapper}>
            <div className={styles.levelLabel}>信用等级</div>
            <div className={styles.level}>
              <Level level={item.sellerCreditLevel || 1} />
            </div>
           </div> */}
        </div>
        <div className={styles.status}>
          <div className={styles.balance}>
            <div className={styles.balanceValue}>
              {amountFormat(item.validAmount)}
            </div>
            <Icon className={styles.currency} name="vcoin" size={["28px", "14px"]} data-sentry-element="Icon" data-sentry-source-file="Item.tsx" />
          </div>
          <div className={cn(styles.orderType, {
          [styles.orderType__separably]: item.isSplit === OrderType.SEPARABLY,
          [styles.orderType__inseparably]: item.isSplit === OrderType.INSEPARABLY
        })}>
            {item.isSplit === OrderType.SEPARABLY ? "可拆分" : "不可拆分"}
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        {item.sellerIndicator && <>
            <div className={styles.bottomItem}>
              <div className={styles.bottomItemValue}>
                {userInfo.creditLevel > +(config?.orderCreditInfoLevel || 0) ? item.sellerIndicator?.totalSuccessfulOrder : '***'}
              </div>
              <div className={styles.bottomItemLabel}>
                {item.sellerIndicator?.range}日成单数
              </div>
            </div>
            <div className={styles.bottomItem}>
              <div className={styles.bottomItemValue}>
              {userInfo.creditLevel > +(config?.orderCreditInfoLevel || 0) ? item.sellerIndicator?.totalSuccessRate : '***'}%
              </div>
              <div className={styles.bottomItemLabel}>
                {item.sellerIndicator?.range}日成单率
              </div>
            </div>
            <div className={styles.bottomItem}>
              <div className={styles.bottomItemValue}>
              {userInfo.creditLevel > +(config?.orderCreditInfoLevel || 0) ? item.sellerIndicator?.buyerOrder + item.sellerIndicator?.sellerOrder : '***'}
              </div>
              <div className={styles.bottomItemLabel}>总交易笔数</div>
            </div>
          </>}
      </div>
    </div>;
};